import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Container, Row, Col, UncontrolledCollapse } from "reactstrap"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons"
import classNames from "classnames"
import WPLink from "components/shared/WPLink"

const MenuList = styled.ul`
	padding: 0;
	margin: 0;
	list-style: none;

	@media ${media.md} {
		padding-bottom: 5rem;
	}

	li {
		text-align: center;
		span {
			/* font-family: ${props => props.theme.font.family.atp}; */
			color: ${props => props.theme.colors.orangeDark};
		}
	}

	ul {
		margin: 0;
		padding: 1rem 0 0 0;
		list-style: none;
		
		@media ${media.md} {
			padding: 0;
		}
		
		.linkWrap {
			position: relative;
		}
		
		a, span {
			display: block;
			color: ${props => props.theme.colors.black};
			font-size: ${props => props.theme.font.size.md};
			font-family: ${props => props.theme.font.family.heading};
			//font-style: italic;
			font-weight: ${props => props.theme.font.weight.regular};
			text-transform: uppercase;
			text-align: center;
			text-decoration: none;
			padding: .25rem 0;
			@media ${media.md} {
				padding-bottom: 0;
			}
			
			&.item-wrapper--double {
				/* padding-bottom: 1.5rem;  */
				
				@media ${media.md} {
					padding: .5rem 0;
				}
			}
			
			&:hover, &.active {
				color: ${props => props.theme.colors.secondary};
				text-decoration: none;
			}
		}
		
		.toggleSubnav {
			position: absolute;
			top: 50%;
			transform: translateY(-50%) rotate(0);
			background: transparent;
			border: 0;
			font-size: 1.5rem;
			color: black;
			right: -2rem;
			
			@media ${media.md} {
				right: 0;
			}
			
			&.active {
				color: ${props => props.theme.colors.primary};
				transform: translateY(-50%) rotate(180deg);
			}
		}
		
		.subNav {
			width: 100%;
			ul {
				list-style: none;
				li {
					a, span {
						color: ${props => props.theme.colors.black};
						font-size: ${props => props.theme.font.size.md};
						
						@media ${media.md} {
							font-size: ${props => props.theme.font.size.xxl};
						}
					}
				}
			}
		}
	}

	.collapse {

		@media ${media.md} {
			display: block;
		}
	}
`

const MenuButton = styled.button`
	cursor: pointer;
	background-color: transparent;
	border: 0;
	text-transform: uppercase;
	color: ${props => props.theme.colors.primary};
	text-align: center;
	width: 100%;
	font-family: ${props => props.theme.font.family.heading};
	font-size: ${props => props.theme.font.size.xl};
	//font-style: italic;
	font-weight: ${props => props.theme.font.weight.regular};
	position: relative;
	
	svg {
		margin-left: 15px;
		color: black;
		transform: ${({ active }) => (active ? 'rotate(180deg)' : 'rotate(0deg)')};
		@media ${media.md} {
			display: none;
		}
		&.active { 

		}
	}
/* 
	@media ${media.md} {
		pointer-events: none;
		cursor: default;
	} */

	&:focus {
		outline: 0;
	}

	.icon {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: -1rem;
		
		@media ${media.md} {
			/* display: none; */
		}
		
		&:before {
			display: block;
			position: relative;
			transform: rotate(0);
		}
	}

	&.active {
		.icon, svg {
			&:before {
				transform: rotate(180deg);
			}
		}
	}
`

const NavFullNav = (props) => {
	const data = useStaticQuery(graphql`
	query {
		allWpMenu(filter: {locations: {eq: PRIMARY_FULL}}) {
			edges {
				node {
					locations
					menuItems {
						nodes {
							id
							path
							target
							label
							parentDatabaseId
							childItems {
								nodes {
									path
									target
									label
								}
							}
						}
					}
				}
			}
		}
	}
	`)

	const menuItems = data.allWpMenu?.edges[0]?.node?.menuItems

	const toggleFullNav = () => {
		document.body.classList.toggle('nav-active')
	}

	const checkLink = (link) => {
		let linkHtml

		if (link.target !== null || link.path.substring(0, 1) !== "/") {
			linkHtml = <a className="item-wrapper" href={link.path} target={link.target} rel="noopener noreferrer" onClick={() => toggleFullNav()} aria-label={link.label}><span dangerouslySetInnerHTML={{ __html: link.label }} /></a>
		} else {
			if (typeof window !== "undefined" && link.path === window.location.pathname) {
				linkHtml = <span className="item-wrapper item-wrapper--double active" dangerouslySetInnerHTML={{ __html: link.label }} />
			} else {
				linkHtml = <WPLink className="item-wrapper" url={link.path} onClick={toggleFullNav}><span dangerouslySetInnerHTML={{ __html: link.label }} /></WPLink>
			}
		}

		return linkHtml
	}

	const mainMenu = menuItems && menuItems.nodes.map((node, i) => {
		if (node.parentDatabaseId === 0) {
			return (
				<Col key={i} md={4} className="pb-4 nav-active">
					<MenuList>
						<li>
							<>
								<MenuButton
									id={`toggler${i}`}
								>
									<span dangerouslySetInnerHTML={{ __html: node.label }} />
									<FontAwesomeIcon icon={faAngleDown}  />
								</MenuButton>
								{node.childItems.nodes.length > 0 &&
									<UncontrolledCollapse toggler={`toggler${i}`}>
										<ul>
											{node.childItems.nodes.map((node, i) => {
												return (
													<li key={i}>
														{checkLink(node)}
													</li>
												)
											})}
										</ul>
									</UncontrolledCollapse>
								}
							</>
						</li>
					</MenuList>
				</Col>
			)
		} 
	})

	return(
		<Container className="py-5">
			<Row className="justify-content-center">
				{mainMenu}
			</Row>
		</Container>
	)
}

export default NavFullNav